import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SmallButtonComponent, TooltipDirective } from '@kaseya-design-components';
import { SsoMappingRulesBannerFacade } from '@layout/sso-mapping-rules-banner/facades/sso-mapping-rules-banner.facade';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { Permission } from '@core/permissions/models/permission.enum';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';

@Component({
  selector: 'itc-sso-mapping-rules-banner',
  templateUrl: 'sso-mapping-rules-banner.component.html',
  styleUrl: 'sso-mapping-rules-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, SmallButtonComponent, TooltipDirective],
})
export class SsoMappingRulesBannerComponent {
  private readonly ssoMappingRulesBannerFacade = inject(SsoMappingRulesBannerFacade);
  private readonly permissionsFacade = inject(PermissionsFacade);
  private readonly router = inject(Router);

  readonly loading = this.ssoMappingRulesBannerFacade.loading;
  readonly hasAccessToThirdPartyIdentityProviderEdit = this.permissionsFacade.hasPermission(Permission.ThirdPartyIdentityProviderEdit);

  goToSingleSignOn(): void {
    this.router.navigate(['/', TopNavigationPath.AdminSettings, 'third-party-idp']);
  }

  acknowledgeBanner(): void {
    this.ssoMappingRulesBannerFacade.acknowledgeBanner();
  }
}
